import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Stats from '../components/Stats';
import Testimonials from '../components/Testimonials';
import GlobalMap from '../components/GlobalMap';
import WarehouseSpotlight from '../components/WarehouseSpotlight';

const Home: React.FC = () => {
  return (
    <div className="relative">
      <Hero />
      <Stats />
      <About />
      <Services />
      <WarehouseSpotlight />
      <Testimonials />
      <GlobalMap />
    </div>
  );
};

export default Home;
